module.exports = __webpack_public_path__ + "static/media/1POLICY46.9ac7c473.jpg";